var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 22,
    viewBox: "0 0 109 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8909,
    cy: 10.8909,
    r: 10.8909,
    fill: "#547966"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.0177,
    cy: 10.8909,
    r: 10.8909,
    fill: "#547966"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57625 10.4067C7.57625 8.61586 8.78416 7.04463 10.5178 6.59526C44.1652 -2.12659 64.5808 -2.27145 99.3167 6.60109C101.061 7.04654 102.279 8.62451 102.279 10.4244C102.279 13.1213 99.6325 15.026 97.0558 14.2299C64.9652 4.31624 44.8947 4.15595 12.8093 14.2015C10.2329 15.0081 7.57625 13.1064 7.57625 10.4067Z",
    fill: "#FBE5B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinding);
export default __webpack_public_path__ + "static/media/Binding.48b5052308c83723b453ddd1fa618c6e.svg";
export { ForwardRef as ReactComponent };